<template lang="html">
  <div class="fullpage-container">
    <div class="wrapper home fullpage-wp" v-fullpage="opts" ref="example">
      <a
        href="#secciondos"
        class="more"
   
      >
        <section class="intro-home row-start page">
          <article class="left"></article>
          <article class="right row-end">
            <div class="contenedor-claim row-center">
              <img
                src="/static/img/claim.png"
                class="claim"
                alt="Carretilla #SeLlevaDesde1875"
              />
            </div>
          </article>

          <rrss></rrss>
          <button @click="moveNext" class="down">
            <img src="/static/img/bajar.svg" alt="Bajar" />
          </button>
        </section>
      </a>

      <section class="historia-esparragos page row-center fww" id="secciondos">
        <article class="left column-end">
          <!-- <img src="/static/img/etiqueta.png" class="img-decoracion etiqueta" alt="">
          <img src="/static/img/etiqueta-1.png" class="img-decoracion etiqueta1" alt=""> -->
          <img
            src="/static/img/img-historia.png"
            class="img-decoracion etiqueta2"
            alt=""
          />
          <!-- <img src="/static/img/foto3.png" class="img-decoracion foto" alt=""> -->

          <div class="white-box">
            <!-- <h2 class="hand-title">Nuestra historia</h2> -->

            <img
              class="decorado"
              src="/static/img/decorado-carretillero.svg"
              alt="Decorado"
              width="200"
            />

            <p>
              Los espárragos en conserva son uno de los productos que incluimos
              en nuestro catálogo desde los inicios de Carretilla en 1875.
            </p>
            <a
              class="more"
              href="http://www.carretilla.info/historia"
              target="_blank"
              >+</a
            >
          </div>
        </article>

        <article class="right">
          <div class="white-box">
            <p>
              A lo largo de estos más de 145 años, nuestra experiencia nos ha
              llevado a ser, hoy en día, especialistas y referente en la
              elaboración de este saludable alimento.
            </p>
            <p>
              Deliciosos espárragos inconfundibles por su calidad, sabor,
              textura tierna y sin hebras.
            </p>
            <p>Descubre aquí todo el catálogo de espárrago Carretilla</p>
            <a
              class="more"
              href="http://www.carretilla.info/conservas-vegetales/esparragos"
              target="_blank"
              >+</a
            >
          </div>
        </article>
      </section>

      <section class="stats-esparragos page row-center fww ais">
        <article class="intro-stats">
          <div class="superior column-center">
            <h3 class="hand-title">Valores de los Espárragos</h3>

            <img
              class="logo"
              src="/static/img/logo-texto-azul.svg"
              alt="Logo carretilla"
            />

            <img
              src="/static/img/decorado-carretillero.svg"
              alt="decorado"
              width="200"
            />
          </div>

          <div class="inferior"></div>
        </article>

        <div class="stats column-center fww">
          <article>
            <h2 class="hand-title">Desde <span>1875</span></h2>
            <img
              src="/static/img/decorado-simple.svg"
              alt="decorado"
              width="200"
              class="decorado"
            />
            <p>
              Los orígenes de la marca Carretilla se remontan a 1875, cuando en
              un taller obrador se comenzaron a elaborar conservas de manera
              artesanal, cocidas al baño maría en recipientes de cristal. El
              fruto de esta experiencia se reconoce en la calidad de nuestros
              productos.
            </p>
            <span class="more">+</span>
          </article>
          <article>
            <h2 class="hand-title">Calidad</h2>
            <img
              src="/static/img/decorado-simple.svg"
              alt="decorado"
              width="200"
              class="decorado"
            />
            <p class="">
              Desde siempre la marca Carretilla ha sido reconocida por la
              calidad de sus espárragos. Siguiendo su método tradicional, los
              cosecha y pela a mano, selecciona los mejores y los envasa
              inmediatamente después de su recogida, para que lleguen a su mesa
              con su inconfundible sabor, color blanco y textura tierna, sin
              hebras.
            </p>
            <span class="more">+</span>
          </article>
          <article>
            <h2 class="hand-title">Naturalidad</h2>
            <img
              src="/static/img/decorado-simple.svg"
              alt="decorado"
              width="200"
              class="decorado"
            />
            <p class="">
              Ofrecemos el máximo estándar de calidad del mercado, gracias al
              cuidado proceso de elaboración de nuestros espárragos, con el que
              se conserva todo el sabor y propiedades nutritivas.
            </p>
            <span class="more">+</span>
          </article>
          <article>
            <h2 class="hand-title">Confianza</h2>
            <img
              src="/static/img/decorado-simple.svg"
              alt="decorado"
              width="200"
              class="decorado"
            />
            <p class="">
              Fruto de la experiencia de una marca “de siempre” y de la calidad
              de nuestros productos, hemos acompañado a generaciones que han
              confiado en Carretilla, siendo hoy en día la marca más reconocida
              en espárrago.
            </p>
            <span class="more">+</span>
          </article>
        </div>
      </section>

      <section class="motivos-esparragos page">
        <h2 class="hand-title main-title">
          ¿Por qué se llevan los Espárragos Carretilla?
        </h2>

        <div class="motivos row-center">
          <article class="motivo">
            <div class="top row-center">
              <h2 class="hand-title">Saludables</h2>
              <!-- <h3>-  -</h3> -->
            </div>
            <div class="bottom">
              <p>
                El espárrago destaca por sus excelentes propiedades
                nutricionales. Es fuente de fibra y tiene un bajo aporte
                calórico. El resultado, un alimento muy aconsejable en una dieta
                sana.
              </p>
            </div>

            <button class="more">✕</button>
          </article>

          <article class="motivo">
            <div class="top row-center">
              <h2 class="hand-title">¡Te ayudan!</h2>
              <!-- <h3>-  -</h3> -->
            </div>
            <div class="bottom">
              <p>
                El espárrago está listo para comer. Solo escurrir y aliñar, si
                lo deseas, a tu gusto. Además resulta muy cómodo ya que lo
                puedes guardar durante mucho tiempo en la despensa
              </p>
            </div>
            <button class="more">✕</button>
          </article>

          <article class="motivo">
            <div class="top row-center">
              <h2 class="hand-title">Gastronomía</h2>
              <!-- <h3>- Alto contenido en fibra -</h3> -->
            </div>
            <div class="bottom">
              <p>
                Con espárragos puedes preparar una gran variedad de recetas para
                todos los gustos y momentos<br />¡Visita nuestra sección de
                recetas!
              </p>
            </div>
            <button class="more">✕</button>
          </article>

          <article class="motivo">
            <div class="top row-center">
              <h2 class="hand-title">Lo auténtico</h2>
              <!-- <h3>- Recomendado en dietas de adelgazamiento -</h3> -->
            </div>
            <div class="bottom">
              <p>
                Lo de siempre...es lo que nos da confianza. El espárrago está en
                nuestras mesas desde siempre, con la marca de siempre, desde
                1875.
              </p>
            </div>
            <button class="more">✕</button>
          </article>
        </div>
      </section>

      <section class="categorias-recetas page column-center">
        <div class="container">
          <h2 class="hand-title main-title">¡Recetas para todos los gustos!</h2>
        </div>

        <div class="categoria-list container row-start">
          <template v-if="!!categoriesRecipes">
            <categoria-el
              :data="categoria"
              :key="key"
              v-for="(categoria, key) in categoriesRecipes"
            ></categoria-el>
          </template>

          <template v-else>
            <categoria-el
              :fake="true"
              :key="key"
              v-for="(categoria, key) in 6"
            ></categoria-el>
          </template>
        </div>
      </section>
      <section>
        <div class="contenedor-ultimas-recetas column-center">
          <div class="container">
            <h2 class="hand-title main-title">¡Últimas Recetas Publicadas!</h2>
          </div>

          <div class="white-section">
            <div class="container row-start recetas-list">
              <template v-if="!!recipes">
                <receta-el
                  :data="receta"
                  :key="key"
                  v-for="(receta, key) in recipes"
                ></receta-el>
              </template>

              <template v-else>
                <receta-el
                  :fake="true"
                  :key="key"
                  v-for="(receta, key) in 3"
                ></receta-el>
              </template>
            </div>

            <div class="container">
              <router-link
                class="classic-btn"
                tooltip="Ver más"
                :to="$t('enlaces.recetas')"
                >Ver más</router-link
              >
            </div>
          </div>
        </div>
      </section>
      <section class="ultimas-recetas page column-center">
        <section class="historia-esparragos platos-listos row-center fww">
          <article class="left row-center">
            <div class="white-box">
              <p class="titulo">¡Descubre los Platos Listos Carretilla!</p>
              <p>
                Más de 70 recetas variadas de Platos Listos para consumir.
                Disfrútalos en casa o llévatelos dónde tú quieras.
              </p>

              <a
                class="more"
                href="https://www.carretilla.info/platos-microondables"
                target="_blank"
                >+</a
              >
            </div>
          </article>

          <div class="contenedor-imagen">
            <img src="/static/img/imagen-platos-listos.jpg" alt="" />
          </div>
        </section>
        <footer-app></footer-app>
      </section>
    </div>
  </div>
</template>

<script lang="js">


import footer from '@/components/parts/footer';

import receta from '@/components/parts/receta-el';
import categoria from '@/components/parts/categoria-home';

import rrss from '@/components/parts/rrss';

import axios from 'axios';
import VueAxios from 'vue-axios';

import { mapGetters, mapActions } from "vuex";

export default {
  name: 'home',
  props: [],
  mounted() {
  this.setData();
    $(".motivo").click(function () {
      $(this).toggleClass('active');
    });

    setTimeout(function () {
      $(".intro-home").addClass('active');
    }, 1000);

    this.checkFullPage();

    var that = this;

    $(window).resize(function (event) {
      that.checkFullPage();
    });

    $(".stats-esparragos .more").click(function () {
      $(".stats-esparragos p").slideUp();
      $(".stats-esparragos .more").show();
      $(".stats-esparragos .decorado").fadeOut();
      $(this).siblings('p').slideDown();
      $(this).siblings('.decorado').fadeIn();
      $(this).hide();
    });


  },
  data() {
    return {
      categorias: '',
      recetas: '',
      recipes : [],
      categoriesRecipes : [],
      opts: {
        start: 0,
        dir: 'v',
        duration: 500,
        responsiveHeight: 800,
        overflow: 'auto',
        beforeChange: function (prev, next) {
        },
        afterChange: function (prev, next) {
          (next >= 1) ? $("header").addClass('min') : $("header").removeClass('min');
          $(".page").removeClass('active');
          $(".page[data-id=" + next + "]").addClass('active');
        }
      }
    }
  },
  components: {
    'receta-el': receta,
    'categoria-el': categoria,
    'footer-app': footer,
    'rrss': rrss
  },
  computed: {
    ...mapGetters(['getLanguage']),
    isNavidad: function () {
      var dateLimit = new Date(2019, 0, 7);
      var actual = new Date();
      var flag = (actual.getTime() <= dateLimit.getTime());

      return flag;

    }
  },
  methods: {
    ...mapActions(["requestReceta" , "requestCategories"]),
    setData() {
        this.requestCategories(data).then((r) => {
        this.categoriesRecipes = r.data;
      });
      let data = {
        length: 7,
        order: [
          {
            name: "created_at",
            direction: "desc",
          },
        ]

      };


      this.requestReceta(data).then((r) => {
        this.recipes = r.data;
      });

    },
    moveNext() {

      if ($(window).height() <= 900) {
        $("html,body").animate({ scrollTop: $(window).height() }, '500');
      } else {
        this.$refs.example.$fullpage.moveNext()
      }
    },
    checkFullPage: function () {
      if ($(window).height() <= 900 || $(window).width() <= 1300) {
        $(".fullpage-container").removeClass('fullpage-container');
        $(".home").removeClass('fullpage-wp anim');
        $(".page").addClass('active');
      }
    }
  },
  watch: {
    'getLanguage': function () {
      this.getData();
      this.setData();
    }
  }
}
</script>

<style scoped>
.fullpage-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: url(/static/img/background-madera.jpg) center bottom/100% auto
    repeat-y;
}

.wrapper.home:not(.fullpage-wp) * {
  opacity: 1;
}

.page {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}

.contenedor-ultimas-recetas {
  width: 100%;
  /* height: calc(100vh - 322px); */
}

.down {
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%) translateY(50%);
  border: none;
  display: block;
  background: none;
  outline: none;
  cursor: pointer;
  z-index: 3;
  opacity: 0;
  transition: 1s;
}

.active .down {
  transition-delay: 2s;
  transform: translateX(-50%) translateY(0);
  opacity: 1;
}

.historia-esparragos .left .hand-title {
  display: none;
}

.claim {
  max-width: 540px;
}

.historia-esparragos {
  background: url("/static/img/bg-dark-wood.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: bottom center;
}
.white-section {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.white-section .classic-btn {
  margin-bottom: 20px;
}
@media screen and (max-height: 1150px) {
  .contenedor-ultimas-recetas {
    justify-content: flex-end;
    -webkit-justify-content: flex-end;
  }
}

@media screen and (max-height: 1010px) {
  .contenedor-ultimas-recetas .hand-title {
    padding-bottom: 20px;
    padding-top: 0;
  }

  .ultimas-recetas .white-section {
    padding: 20px 0;
  }
}

@media screen and (max-width: 1500px) {
}

@media screen and (max-height: 900px), screen and (max-width: 1300px) {
  .contenedor-claim {
    justify-content: center;
  }

  .home {
    transform: none !important;
  }

  .fullpage-container {
    overflow: visible;
  }

  .page {
    height: auto !important;
  }

  .intro-home {
    min-height: 100vh;
  }

  .intro-home .left {
    min-height: 100vh;
  }

  .contenedor-claim {
    padding-left: 0;
  }

  .historia-esparragos .left {
    opacity: 1;
    padding-top: 100px;
  }

  .historia-esparragos .left .etiqueta {
    display: inline-block;
    width: auto;
    height: auto;
    max-height: 100%;
  }

  .historia-esparragos .left .etiqueta1 {
    bottom: 30px;
    left: auto;
    right: 20px;
    max-width: 60vw;
  }

  .historia-esparragos .left .etiqueta2 {
    top: 0px;
    left: 0px;
  }

  .historia-esparragos .left .foto {
    display: inline-block;
    bottom: 50px;
  }

  .historia-esparragos .right {
    padding-bottom: 400px;
  }

  .motivos-esparragos {
    padding-top: 50px;
  }

  .categorias-recetas {
    padding-top: 50px;
  }

  .motivos {
    padding: 40px 20px;
    height: auto;
  }

  .motivo {
    margin-bottom: 20px;
  }

  .contenedor-ultimas-recetas {
    height: auto;
    padding-top: 50px;
  }

  .motivos-esparragos .hand-title.main-title {
    padding-top: 0;
  }
}

@media screen and (max-width: 1025px) {
  .wrapper.home:not(.fullpage-wp) .intro-home .left {
    min-height: 50vh;
    height: 50vh;
    width: 100%;
    top: 0;
    background-position: center 60%;
    position: relative;
  }

  .intro-home .right {
    padding-top: 100px;
    height: auto;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    background: url(/static/img/background-madera-responsive.jpg);
    background-size: cover;
    background-repeat: no-repeat;
  }

  .contenedor-claim {
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .intro-home .left .tapa {
    display: none;
  }

  .intro-home .campo {
    display: none;
  }

  .intro-home .right {
    height: 100vh;
    padding-top: 25vh;
  }

  .wrapper.home:not(.fullpage-wp) .intro-home .left {
    height: 75vh;
  }

  .wrapper.home:not(.fullpage-wp) .intro-home .left {
    min-height: 100vh;
    -webkit-transform: translateY(-100vh);
    transform: translateY(-60vh);
    margin-bottom: -100vh;
    background-position: bottom;
    height: 100vh;
    background-size: contain;
  }
}

@media screen and (max-width: 768px) {
  .historia-esparragos .left .etiqueta2 {
    max-width: 500px;
  }

  .contenedor-claim img {
    max-width: 400px;
  }

  .historia-esparragos article {
    padding: 20px;
  }

  .white-box {
    padding: 10px;
  }

  .white-box p {
    font-size: 16px;
    line-height: 24px;
  }

  .historia-esparragos .right {
    padding-bottom: 50px;
  }

  .stats-esparragos .intro-stats {
    width: 100%;
    height: auto;
  }

  .wrapper.home:not(.fullpage-wp) .stats-esparragos .intro-stats .inferior {
    min-height: 0;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }

  .stats-esparragos .intro-stats .superior {
    position: relative;
    left: auto;
    top: auto;
    z-index: 3;
    height: auto;
  }

  .stats-esparragos .stats {
    width: 100%;
    padding: 20px 10px;
  }

  .stats-esparragos .stats > article p {
    display: inline-block;
    font-size: 16px;
    margin-top: 10px;
  }

  .stats-esparragos .stats > article .more {
    display: none;
  }

  .stats-esparragos .stats > article .decorado {
    display: inline-block;
    margin-bottom: 0;
  }

  .active .down {
    transform: translateX(-50%) translateY(0) scale(0.8);
  }
}

@media screen and (max-width: 600px) {
  .motivo .top,
  .motivo .bottom {
    width: 100%;
  }

  .historia-esparragos .left .img-decoracion {
    display: none;
  }

  .contenedor-claim img {
    max-width: 300px;
  }

  .historia-esparragos .left .etiqueta2 {
    height: auto;
    display: inline-block;
    max-width: 100vw;
  }

  .intro-home .left[navidad="true"],
  .wrapper.home:not(.fullpage-wp) .intro-home .left[navidad="true"] {
    background: url(/static/img/background-home-left-navidad-mvl.jpg) center
      bottom/cover no-repeat;
  }

  .active .down {
    transform: translateX(-50%) translateY(0) scale(0.6);
  }

  .contenedor-claim img {
    max-width: 300px;
  }

  .intro-home .right {
    padding-top: 200px;
  }

  .wrapper.home:not(.fullpage-wp) .intro-home .left {
    height: 100vh;
  }

  .wrapper.home:not(.fullpage-wp) .intro-home .left {
    min-height: 100vh;
  }

  .nuevaimagen {
    max-width: 180px;
  }

  .wrapper.home:not(.fullpage-wp) .intro-home .left {
    transform: translateY(-70vh);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/home.vue